<script>
export default {
  install(Vue) {
    Vue.$link = new function () {
      var pathName = function (post) {
        var type = post.type | post.typeId;
        return Vue.$types.getPathName(type);
      }
      return {
        viewPost: function (contextPath, post) {
          return contextPath + "/" + pathName(post) + "/view/" + post.id + "/" + Vue.$slugUtil.withUnderscores(post.name);
        },
        viewSupplement: function (contextPath, supplement) {
          return contextPath + "/supplement/view/" + supplement.id + "/" + Vue.$slugUtil.withDashes(supplement.name);
        },
      };
    }
  }
}
</script>